module.exports = __webpack_public_path__ + "img/img_32389_0_131.6ab40400.png";